import React from "react";
import { Link } from "gatsby";
import "../styles/Footer.css";
import { StaticImage } from "gatsby-plugin-image";
import socialLinks from "../constants/social_links";

const Footer = () => {
  return (
    <>
      <section className="footer-section">
        <div className="footer-first-sect">
          <div className="footer-col-one">
            <StaticImage
              src="../images/omega-logo.png"
              className="footer-logo"
              alt="omega logo"
              quality={100}
              loading="lazy"
              placeholder="tracedSVG"
            />
          </div>
          <div className="footer-col-two">
            <div className="footer-list">
              <span>Compañia</span>
              <ul>
                <Link to="/servicios/" activeClassName="active-page">
                  <li>FCm</li>
                </Link>
                <Link to="/nosotros/" activeClassName="active-page">
                  <li>Nosotros</li>
                </Link>
                <Link to="/turismo/" activeClassName="active-page">
                  <li>Turismo</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-sec-sect">
          <div className="footer-col-three">
            <div className="footer-list">
              <span>Viajes</span>
              <ul>
                <Link to="/destinos/" activeClassName="active-page">
                  <li>Destinos</li>
                </Link>
                <Link to="/promociones/" activeClassName="active-page">
                  <li>Promociones</li>
                </Link>
                <Link to="/info-viajes/" activeClassName="active-page">
                  <li>Info Viajes</li>
                </Link>
              </ul>
            </div>
          </div>
          <div className="footer-col-four">
            <div className="footer-list">
              <span>Soporte</span>
              <ul>
                <Link to="/contactanos/" activeClassName="active-page">
                  <li>Contactanos</li>
                </Link>
                <a href="tel:+582122092800">
                  <li>
                    <strong>Telefono:</strong> 02122092800
                  </li>
                </a>
                <li>
                  <strong>Email: </strong> info@omega.com.ve
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <div className="copyright-bar">
        <p>
          <span>Agencia de viajes Omega</span> &copy; {new Date().getFullYear()}{" "}
          Caracas, Venezuela
        </p>
        <div className="social-links-footer">
          {socialLinks.map((link) => {
            return (
              <a
                target="_blank"
                rel="noreferrer"
                className="social-link-footer"
                href={link.url}
                key={link.id}
              >
                {link.icon}
              </a>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Footer;
